/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanClubTextPostNotificationActionData
 */
export interface FanClubTextPostNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotificationActionData
     */
    commentId: string;
}

/**
 * Check if a given object implements the FanClubTextPostNotificationActionData interface.
 */
export function instanceOfFanClubTextPostNotificationActionData(value: object): value is FanClubTextPostNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "commentId" in value && value["commentId"] !== undefined;

    return isInstance;
}

export function FanClubTextPostNotificationActionDataFromJSON(json: any): FanClubTextPostNotificationActionData {
    return FanClubTextPostNotificationActionDataFromJSONTyped(json, false);
}

export function FanClubTextPostNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanClubTextPostNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'commentId': json['comment_id'],
    };
}

export function FanClubTextPostNotificationActionDataToJSON(value?: FanClubTextPostNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'comment_id': value.commentId,
    };
}

